import { clientConfig } from "app/config";
import { AssetClass } from "interfaces/enums";
// TODO: remove usage of config here

export const getSearchPageUrl = (searchTerm?: string) => {
    return `${clientConfig.urlPathPrefixStocks}suche${searchTerm ? `?q=${encodeURIComponent(searchTerm)}` : ""}`;
};

export const getSearchAPIUrl = (searchTerm: string) =>
    `${clientConfig.apiURL}/detailsearch?searchTerm=${encodeURIComponent(searchTerm)}`;

export const getSearchLoadMoreUrl = (searchTerm: string, assetClass: AssetClass, limit: number, offset: number) =>
    `${getSearchAPIUrl(searchTerm)}&assetClass=${assetClass}&offset=${offset}&limit=${limit}`;

export const getQuickSearchAPIUrl = (searchTerm: string) =>
    `${clientConfig.apiURL}/suggestsearch?searchTerm=${encodeURIComponent(searchTerm)}`;

export const getStockIndexConstituentsAPIUrl = (apiURL: string, valor: number, offset = 0, limit = 30) =>
    `${apiURL}/constituents?valor=${valor}&offset=${offset}&limit=${limit}`;
